/**
@description 面包导航
*/
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
class Breadcrumb extends Component {
  componentDidMount(){
  }

  breadCrumbUrl(url){
    let childerCatname
    let catname=url.substr(1,url.length-1)
    if(url=='/product'){
      childerCatname='payPeriodLoan'
    }else if(url=='/recruitment'){
      childerCatname='jobRecruitment'
    }else if(url=='/aboutUs'){
      childerCatname='company'
    }else if(url=='/loanHelp'){
      childerCatname='loanApply'
    }else if(url=='/'){
      childerCatname=''
    }
   return this.props.menuChilderUrl(catname,childerCatname)
  }

  render() {
    const {router} = this.props
    let routes = []//路由
    let currentRoute
    let prevRoute
    let path

    this.props.routes && this.props.routes.map((route, i) => {

      if (prevRoute) {
        if (prevRoute.path.substr(-1) === '/') {
          path = prevRoute.path + route.path
        } else {
          path = prevRoute.path + '/' + route.path
        }
      } else {
        path = route.path
      }

      if (!route.name ) {
        route.name = this.props.displayMissingText
      }

      currentRoute = {
        name: route.name,
        path: path,
        className : (this.props.routes.length - 1 === i)  ?  'current' : 'active'
      }

      routes.push(currentRoute)
      prevRoute = currentRoute

    })

    if (router.location.pathname === '/' || 
      router.location.pathname === '/404' ||
      router.location.pathname === '/qrCode') {
      return null
    } else {
      return(
        <div className="page-location  area clearfix">{/**面包屑*/}
          当前位置：
          {/* <Link to="/">首页</Link>
          &nbsp;>>&nbsp;
          {breadcrumbLinkList} */}
          {
            routes.map((item, i) => {
            if (i === routes.length - 1) {{/**最后一个，即当前路径*/}
              return (<span key={i}>
                <span>{item.name}</span>
              </span>)
            } else {{/**不是最后一个路径*/}
              return (
                <span key={i}>
                  <a className={item.className} href={this.breadCrumbUrl(item.path)}>{item.name=='首页'?'中腾信':item.name}</a>
                  <span> >> </span>
                </span>
              )
            }
          })
        }
        </div>
      )
    }
  }
}

Breadcrumb = connect(state => ({}), {})(Breadcrumb)
export default Breadcrumb



// WEBPACK FOOTER //
// ./components/layout/Breadcrumb.js